const selectStandardLabelColors: object = {
  "blue-gray": {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-blue-gray-500",
    },
    open: {
      color: "text-blue-gray-500",
      after: "after:border-blue-gray-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-blue-gray-50",
    },
  },
  gray: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-gray-500",
    },
    open: {
      color: "text-gray-500",
      after: "after:border-gray-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-gray-500",
    },
  },
  brown: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-brown-500",
    },
    open: {
      color: "text-brown-500",
      after: "after:border-brown-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-brown-500",
    },
  },
  "deep-orange": {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-deep-orange-500",
    },
    open: {
      color: "text-deep-orange-500",
      after: "after:border-deep-orange-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-deep-orange-500",
    },
  },
  orange: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-orange-500",
    },
    open: {
      color: "text-orange-500",
      after: "after:border-orange-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-orange-500",
    },
  },
  amber: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-amber-500",
    },
    open: {
      color: "text-amber-500",
      after: "after:border-amber-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-amber-500",
    },
  },
  yellow: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-yellow-500",
    },
    open: {
      color: "text-yellow-500",
      after: "after:border-yellow-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-yellow-500",
    },
  },
  lime: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-lime-500",
    },
    open: {
      color: "text-lime-500",
      after: "after:border-lime-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-lime-500",
    },
  },
  "light-green": {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-light-green-500",
    },
    open: {
      color: "text-light-green-500",
      after: "after:border-light-green-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-light-green-500",
    },
  },
  green: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-green-500",
    },
    open: {
      color: "text-green-500",
      after: "after:border-green-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-green-500",
    },
  },
  teal: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-teal-500",
    },
    open: {
      color: "text-teal-500",
      after: "after:border-teal-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-teal-500",
    },
  },
  cyan: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-cyan-500",
    },
    open: {
      color: "text-cyan-500",
      after: "after:border-cyan-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-cyan-500",
    },
  },
  "light-blue": {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-light-blue-500",
    },
    open: {
      color: "text-light-blue-500",
      after: "after:border-light-blue-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-light-blue-500",
    },
  },
  blue: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-blue-500",
    },
    open: {
      color: "text-blue-500",
      after: "after:border-blue-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-blue-500",
    },
  },
  indigo: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-indigo-500",
    },
    open: {
      color: "text-indigo-500",
      after: "after:border-indigo-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-indigo-500",
    },
  },
  "deep-purple": {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-deep-purple-500",
    },
    open: {
      color: "text-deep-purple-500",
      after: "after:border-deep-purple-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-deep-purple-500",
    },
  },
  purple: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-purple-500",
    },
    open: {
      color: "text-purple-500",
      after: "after:border-purple-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-purple-500",
    },
  },
  pink: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-pink-500",
    },
    open: {
      color: "text-pink-500",
      after: "after:border-pink-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-pink-500",
    },
  },
  red: {
    close: {
      color: "text-blue-gray-500",
      after: "after:border-red-500",
    },
    open: {
      color: "text-red-500",
      after: "after:border-red-500",
    },
    withValue: {
      color: "text-blue-gray-500",
      after: "after:border-red-500",
    },
  },
};

export default selectStandardLabelColors;
